<template>
  <div class="d-flex justify-content-center align-items-center">
      <CheckPermission permission="ED018">
        <b-button
          data-cy="details"
          v-b-modal="`modal-details-${file.idAprobacion}`"
          variant="secondary"
          class="btn-icon rounded-circle p-3"
          size="sm"
          v-on:click="onOptionGetGeneralDetailsFile(file)"
        >
          <feather-icon icon="SearchIcon" />
        </b-button>
      </CheckPermission>
      <div v-tooltip="'Desplegar acciones'">
        <b-dropdown
          v-has-permission="'ED096'"
          variant="link"
          no-caret
          right
        >
          <template #button-content>
            <feather-icon
              data-cy="gear-button"
              width="24px"
              height="24px"
              icon="SettingsIcon"
              class="align-middle text-body"
            />
          </template>
          <CheckPermission permission="ED016">
            <b-dropdown-item
              data-cy="continue-draft"
              v-if="isDraft && !isInputDocForm"
              v-on:click="openDraft()"
            >
              <vs-icon icon="query_builder" />
              Continuar borrador
            </b-dropdown-item>
            <b-dropdown-item
              data-cy="delete-draft"
              v-if="isDraft && !isInputDocForm"
              v-on:click="deleteDraft(file)"
            >
              <vs-icon icon="delete" />
              Descartar borrador
            </b-dropdown-item>
            <b-dropdown-item
              data-cy="continue-form"
              v-if="isDraft && isInputDocForm"
              v-on:click="openInputFormDraft()"
            >
              <vs-icon icon="query_builder" />
              Continuar ingreso
            </b-dropdown-item>
          </CheckPermission>
          <CheckPermission permission="ED140">
            <b-dropdown-item
              data-cy="Edit"
              v-if="isInputDocForm && (onIncompleteFiles || onGeneralFiles) && canEditFile"
              v-on:click="openInputDocForm()"
            >
              <vs-icon icon="edit" />
              Editar
            </b-dropdown-item>
          </CheckPermission>
          <CheckPermission permission="ED146">
            <b-dropdown-item
              data-cy="edit-file"
              v-if="canEditFileWizard"
              v-on:click="onEditFile()"
            >
              <vs-icon icon="edit" />
              Editar Exp.
            </b-dropdown-item>
          </CheckPermission>
          <CheckPermission permission="ED017">
            <b-dropdown-item
              data-cy="binnacle"
              v-if="!isShared"
              v-on:click="onOptionBinnacleFile(file)"
            >
              <vs-icon icon="list" />
              Bitácora
            </b-dropdown-item>
          </CheckPermission>
          <CheckPermission
            permission="ED039"
            v-if="!isAguasAndinas"
          >
            <b-dropdown-item
              data-cy="answer-option"
              v-on:click="onAnswerFile(file)"
              v-if="!isDraft && onPendingFiles && isAssigned
            && !isProcessed && !isCancelled && !isShared"
            >
              <vs-icon icon="storage" />
              Responder
            </b-dropdown-item>
          </CheckPermission>
          <CheckPermission permission="ED040">
            <b-dropdown-item
              data-cy="return-file"
              v-on:click="onOptionReturnFile(file)"
              v-if="!isDraft && onPendingFiles && isAssigned
              && file.solicitanteDocumentoId !== currentUserId
              && !isProcessed && !isCancelled && !isShared"
            >
              <vs-icon icon="keyboard_backspace" />
              Devolver expediente
            </b-dropdown-item>
          </CheckPermission>
          <CheckPermission
            permission="ED134"
            v-if="isAguasAndinas"
          >
            <b-dropdown-item
              data-cy="answer"
              v-on:click="onResponseFile(file)"
              v-if="!isDraft && onPendingFiles && isAssigned
              && !isProcessed && !isCancelled && !isShared && canRespond"
            >
              <vs-icon icon="storage" />
              Responder
            </b-dropdown-item>
          </CheckPermission>
          <CheckPermission permission="ED026">
            <b-dropdown-item
              data-cy="send-document"
              v-on:click="onOptionSendFile(file)"
              v-if="!isDraft && onPendingFiles && !hasTwoRecipients && isAssigned
             && isResponsible && !isProcessed && !isCancelled && !isShared"
            >
              <vs-icon icon="call_made" />
              Enviar documento
            </b-dropdown-item>
          </CheckPermission>
          <CheckPermission permission="DNT58">
            <b-dropdown-item
              data-cy="notify-document"
              v-on:click="onOptionNotifyFile(file)"
              v-if="onGeneralFiles || onPendingFiles"
            >
              <vs-icon icon="notifications" />
              Notificar a usuarios
            </b-dropdown-item>
          </CheckPermission>
          <CheckPermission permission="ED231">
            <b-dropdown-item
              data-cy="mark-sent-document"
              v-if="isAguasAndinas && (!file.enviadoOpenText || file.enviadoOpenText === 'N')"
              v-on:click="onOptionMarkSentFile(file, 'enviar')"
            >
              <vs-icon icon="trending_up" />
              Marcar enviado
            </b-dropdown-item>
            <b-dropdown-item
              data-cy="mark-unsent-document"
              v-if="isAguasAndinas && (file.enviadoOpenText && file.enviadoOpenText === 'Y')"
              v-on:click="onOptionMarkSentFile(file, 'no-enviar')"
            >
              <vs-icon icon="trending_up" />
              Marcar no enviado
            </b-dropdown-item>
          </CheckPermission>
          <CheckPermission permission="ED024">
            <b-dropdown-item
              data-cy="participants"
              v-if="!isShared"
              v-on:click="onOptionGetParticipants(file)"
            >
              <vs-icon icon="group" />
              Participantes
            </b-dropdown-item>
          </CheckPermission>
          <CheckPermission permission="ED018">
            <b-dropdown-item
              data-cy="target-process"
              v-if="!isShared"
              v-on:click="onOptionTimelineFile(file)"
            >
              <vs-icon icon="all_inbox" />
              Proceso Destinos
            </b-dropdown-item>
          </CheckPermission>
          <CheckPermission permission="ED025">
            <b-dropdown-item
              data-cy="comments"
              v-on:click="onOptionGetComments(file)"
              v-if="!isDraft && onPendingFiles && isAssigned
             && isResponsible && !isProcessed && !isCancelled && !isShared"
            >
              <vs-icon icon="chat" />
              Comentarios
            </b-dropdown-item>
          </CheckPermission>
          <b-dropdown-item
            data-cy="see-reference"
            v-if="!isShared"
            v-on:click="onOptionReferencesFile(file)"
          >
            <vs-icon icon="device_hub" />
            Ver Referencias
          </b-dropdown-item>
          <CheckPermission permission="ED020">
            <b-dropdown-item
              data-cy="download-file"
              v-on:click="onOptionDownloadAttachments(file)"
            >
              <vs-icon icon="save_alt" />
              Descargar expediente
            </b-dropdown-item>
          </CheckPermission>
          <CheckPermission permission="ED021">
            <b-dropdown-item
              data-cy="assign-me-file"
              v-on:click="onOptionAssignFile(file)"
              v-if="
              (
                !isDraft &&
                onPendingFiles &&
                !isAssigned &&
                !isProcessed &&
                !isCancelled &&
                !isShared
                )
              || canAssignMeFile
"
            >
              <vs-icon icon="how_to_reg" />
              Asignarme expediente
            </b-dropdown-item>
          </CheckPermission>
          <CheckPermission
            permission="ED150"
            v-if="isAguasAndinas"
          >
            <b-dropdown-item
              data-cy="see-answer"
              v-on:click="onViewResponseFile(file)"
              v-if="!isDraft && onPendingFiles && isAssigned
             && isResponsible && !isProcessed && !isCancelled && !isShared && isResponse"
            >
              <vs-icon icon="storage" />
              Ver Respuesta
            </b-dropdown-item>
          </CheckPermission>
          <b-dropdown-item
            data-cy="cancel-file"
            v-has-permission="'ED022|ED138'"
            v-on:click="onOptionCancelFile(file)"
            v-if="verifyUserPermission"
          >
            <vs-icon icon="clear" />
            Anular expediente
          </b-dropdown-item>
          <CheckPermission permission="ED023">
            <b-dropdown-item
              data-cy="finalize-document"
              v-on:click="onOptionProcessFile(file)"
              v-if="verifyProcessPermission"
            >
              <vs-icon icon="move_to_inbox" />
              Finalizar documento
            </b-dropdown-item>
          </CheckPermission>
          <CheckPermission permission="ED098">
            <b-dropdown-item
              data-cy="file-document"
              v-on:click="onOptionArchiveFile(file)"
              v-if="isArchivable"
            >
              <vs-icon icon="move_to_inbox" />
              Archivar documento
            </b-dropdown-item>
          </CheckPermission>
          <CheckPermission
            permission="ED232"
            v-if="canRecover"
          >
            <b-dropdown-item
              v-on:click="onOptionRecoverFile(file)"
              data-cy="rescue-file"
            >
              <feather-icon icon="RotateCcwIcon" />
              <span>
            Rescatar expediente
          </span>
            </b-dropdown-item>
          </CheckPermission>
          <CheckPermission permission="ED099">
            <b-dropdown-item
              data-cy="see-process-record"
              v-if="watchProcessFile"
              v-on:click="getProcessDocument(file)"
            >
              <vs-icon icon="description" />
              Ver acta de proceso
            </b-dropdown-item>
          </CheckPermission>
          <b-dropdown-item
            data-cy="send-to-flow"
            v-on:click="onOptionSendToFlowFile(file)"
            v-if="canSendToFlow"
          >
            <vs-icon icon="call_split" />
            Enviar a flujo
          </b-dropdown-item>
          <CheckPermission permission="ED113">
            <b-dropdown-item
              data-cy="send-to-comptroller"
              v-on:click="onOptionSendControlFile(file)"
              v-if="isNumbered"
            >
              <vs-icon icon="exit_to_app" />
              Enviar a contraloría
            </b-dropdown-item>
          </CheckPermission>
          <CheckPermission permission="ED114">
            <b-dropdown-item
              data-cy="Received-from-comptroller"
              v-on:click="onOptionControlReceived(file)"
              v-if="isOnControl"
            >
              <vs-icon icon="gavel" />
              Recibido de contraloría
            </b-dropdown-item>
          </CheckPermission>
          <CheckPermission permission="ED058">
            <b-dropdown-item
              v-on:click="onOptionOpenActivityBoard(file)"
              v-if="canGoKanban"
              data-cy="activity-board"
            >
              <vs-icon icon="developer_board" />
              Actividades
            </b-dropdown-item>
          </CheckPermission>
          <CheckPermission
            permission="ED139"
            v-if="isAguasAndinas"
          >
            <b-dropdown-item
              data-cy="sign-response"
              v-on:click="onOptionSignAnswer(file)"
              v-if="!isDraft && onPendingFiles && isAssigned
             && isResponsible && !isProcessed && !isCancelled && !isShared && isResponse"
            >
              <vs-icon icon="assignment_turned_in" />
              Firmar respuesta
            </b-dropdown-item>
          </CheckPermission>
          <CheckPermission permission="ED027">
            <b-dropdown-item
              data-cy="help-ticket"
              v-on:click="onTicketFile(file)"
              v-if="!isDraft && !isShared"
            >
              <vs-icon icon="help" />
              Ticket de ayuda
            </b-dropdown-item>
          </CheckPermission>
          <CheckPermission permission="ED127">
            <b-dropdown-item
              data-cy="upload-document"
              @click="onOptionGetGeneralDetailsFile(file, 'loadDocuments')"
              v-if="onEnteredFiles"
            >
              <vs-icon icon="cloud_upload" />
              Cargar docs.
            </b-dropdown-item>
          </CheckPermission>
          <CheckPermission permission="ED128">
            <b-dropdown-item
              @click="completeMetadata"
              v-if="onIncompleteFiles"
            >
              <vs-icon
                icon="edit"
                data-cy="complete-information"
              />
              Completar información
            </b-dropdown-item>
          </CheckPermission>
          <CheckPermission permission="ED115">
            <b-dropdown-item
              @click="onSendDocDigital(file)"
              v-if="canSendDocDigital"
              data-cy="submit-doc-digital"
            >
              <vs-icon icon="edit" />
              Enviar a DocDigital
            </b-dropdown-item>
          </CheckPermission>
          <CheckPermission permission="ED274">
            <b-dropdown-item
              @click="updatePrivacity(file)"
              data-cy="update-privacy"
            >
              <vs-icon icon="edit"/>
              Actualizar privacidad
            </b-dropdown-item>
          </CheckPermission>
        </b-dropdown>
      </div>
    </div>
</template>
<script>

import { mapActions, mapGetters } from 'vuex';

import { types } from '@/febos/chile/dnt/config/wizard';
import CheckPermission from '@/febos/global/usuario/components/CheckPermission';
import router from '@/router';
import { getProcessDocument } from '@/febos/servicios/api/dnt.api';
import { ACTIVE } from '@/febos/chile/dnt/mixins/RecipientStatusTypes';
import { SUBJECT } from '@/febos/chile/dnt/mixins/RecipientTypes';

export default {
  components: { CheckPermission },
  props: [
    'file',
    'onPendingFiles',
    'onGeneralFiles',
    'onEnteredFiles',
    'onIncompleteFiles',
    'onPreSalida',
    'isDraft',
    'isAssigned',
    'isProcessed',
    'isArchivable',
    'watchProcessFile',
    'isCancelled',
    'isResponsible',
    'selectFile',
    'isShared',
    'isInternFile',
    'isNumbered',
    'isOnControl',
    'canAssignMeFile',
    'canProcess',
    'canProcessAnswer',
    'canCancel',
    'canCancelAdmin',
    'canSendToFlow',
    'canEditFile',
    'canEditFileWizard',
    'isResponse',
    'canSendDocDigital',
    'canRespond',
    'canRecover'
  ],
  data() {
    return {
      loading: false
    };
  },
  computed: {
    ...mapGetters('Empresas', [
      'company'
    ]),
    ...mapGetters('Usuario', [
      'currentUserId',
      'hasPermission'
    ]),
    isConvention() {
      return this.company.iut === '60100003-2';
    },
    isSiss() {
      return this.company.iut === '61221000-4';
    },
    hasTwoRecipients() {
      return this.file.destinatarios
        && this.file.destinatarios
          .filter(
            (destinatario) => destinatario.tipoDestino === SUBJECT
              && destinatario.estado === ACTIVE
          ).length >= 2;
    },
    isInputDocForm() {
      return this.file.transporteEmbalajeTara === 'inputDocForm';
    },
    verifyUserPermission() {
      const isAdmin = this.hasPermission('ED138');
      if (isAdmin && this.canCancelAdmin) {
        return true;
      }
      if (this.isSiss) {
        const APPROVED = 12;
        return !isAdmin && this.canCancel && this.file.estado !== APPROVED;
      }
      return !isAdmin && this.canCancel;
    },
    verifyProcessPermission() {
      const isAdmin = this.hasPermission('ED151');
      if (isAdmin && this.canProcessAnswer) {
        return true;
      }
      return !isAdmin && this.canProcess;
    },
    isAguasAndinas() {
      return this.company.iut === '61808000-5';
    },
    isSanitary() {
      return this.company.iut === '61221000-4';
    },
    canGoKanban() {
      if (this.isAguasAndinas) {
        return !this.isDraft && (this.onPendingFiles || this.onGeneralFiles) && this.isAssigned
          && !this.isCancelled && !this.isShared;
      }
      return !this.isDraft && this.onPendingFiles && this.isAssigned
        && this.isResponsible && !this.isProcessed && !this.isCancelled && !this.isShared;
    }
  },
  methods: {
    ...mapActions('Modals', [
      'showModals'
    ]),
    ...mapActions('Dnts', [
      'getFileDnt',
      'downloadFilePDF',
      'attemptCancelFile',
      'getFileBinnacle',
      'sendTicketHelp',
      'downloadAttachmentFiles',
      'getFileComments',
      'getAttachmentsDnt',
      'getFileTimeline',
      'answerCreateFile',
      'searchReferences',
      'controlDntFileED',
      'deleteDraftDntFileED',
      'updateSentMetadataStatus',
      'docDigitalDntFileED'
    ]),
    ...mapActions('Empresas', [
      'getUsersCompany',
      'getGroupsCompany',
      'getUserSigns'
    ]),
    ...mapActions('docDigital', [
      'fetchOptionsDocDigital'
    ]),
    onOptionRecoverFile(file) {
      this.selectFile(file);
      this.showModals('recoverFile');
    },
    completeMetadata() {
      if (this.isConvention) {
        this.$router.push({
          name: 'conventionMetadataForm',
          query: { febosId: this.file.febosId }
        });
      }
      if (this.isSanitary) {
        this.$router.push({
          name: 'files-wizard-update',
          params: {
            id: this.file.febosId,
            wizard: types[this.file.claseMercadoPublico]
          },
          query: { from: 'completeFiles' }
        });
      }
    },
    openDraft() {
      this.$router.push(`/documentos/${types[this.file.claseMercadoPublico]}/${this.file.febosId}`);
    },
    async deleteDraft(file) {
      this.selectFile(file);
      const toProcess = {
        febosId: file.febosId,
        estadoId: 101
      };
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: 'Heey!',
        text: 'Si continuas éste expediente quedará descartado',
        cancelText: 'Cancelar',
        acceptText: 'Confirmar',
        accept: async () => {
          await this.deleteDraftDntFileED(toProcess);
          await this.$bvToast.toast(
            'Vale, se ha descartado el borrador',
            {
              title: '¡Genial!',
              variant: 'primary',
              pauseOnHover: true,
              solid: true,
              autoHideDelay: 4000
            }
          );
        },
        cancel: () => {
        }
      });
    },
    openInputFormDraft() {
      this.$router.push({
        name: 'conventionInputForm',
        query: { febosId: this.file.febosId },
        params: { from: 'draftTray' }
      });
    },
    openInputDocForm() {
      const routeData = this.$router.resolve({
        name: 'conventionInputForm',
        query: { febosId: this.file.febosId },
        params: { from: 'edit' }
      });
      window.open(routeData.href, '_blank');
    },
    onEditFile() {
      const routeData = this.$router.resolve({
        name: 'files-wizard-update',
        params: {
          wizard: types[this.file.claseMercadoPublico],
          id: this.file.febosId
        }
      });
      window.open(routeData.href, '_blank');
    },
    onOptionAssignFile(file) {
      this.selectFile(file);
      this.showModals('asignFile');
    },
    onOptionSignAnswer(file) {
      this.$router.push({
        name: 'new-flow',
        params: {
          wizard: 'newFlow',
          file
        },
        query: {
          origin: 'respuesta',
          numero: file.numero,
          febosId: file.febosId
        }
      });
    },
    onSendToFlow(file) {
      this.selectFile(file);
      return router.push({
        name: 'files-wizard-update',
        params: {
          wizard: 'flujo',
          id: file.febosId
        }
      });
    },
    onAnswerFile(file) {
      this.selectFile(file);
      const twoSubjects = 2;
      const destinatarios = file.destinatarios.filter((recipient) => recipient.tipoDestino === 1);
      if (this.isConvention && destinatarios.length === twoSubjects
        && this.currentUserId === destinatarios[1].destinoListaCodigo
      ) {
        this.$router.push({
          name: 'new-flow',
          params: { wizard: 'newFlow' }
        });
      } else {
        this.showModals('answerFile');
      }
    },
    onOptionGetDetailsFile(file) {
      this.selectFile(file);
      this.getFileDnt({
        febosId: file.febosId,
        destinatarios: 'si',
        referencias: 'si',
        adjuntos: 'si'
      });
      this.showModals('detailsFile');
    },
    async onOptionGetGeneralDetailsFile(file, loadDocuments) {
      if (loadDocuments) {
        this.$store.commit('Dnts/LOADING_DOCS', true);
      } else {
        this.$store.commit('Dnts/LOADING_DOCS', false);
      }
      this.selectFile(file);
      await this.getFileDnt({
        febosId: file.febosId,
        dnt: 'si',
        retornarDnt: 'si',
        destinatarios: 'si',
        etiquetas: 'si',
        referencias: 'si',
        adjuntos: 'si',
        metadata: 'si',
        docDigitalAutores: 'si',
        docDigitalParticipantes: 'si'
      });
      await this.getFileComments({
        febosId: file.febosId
      });
      await this.showModals('generalDetailsFile');
    },
    async onOptionTimelineFile(file) {
      this.selectFile(file);
      await this.getFileTimeline(file.febosId);
      await this.showModals('timeline');
    },
    async onOptionBinnacleFile(file) {
      this.selectFile(file);
      await this.getFileBinnacle({
        febosId: file.febosId,
        filas: 200,
        pagina: 1
      });
      await this.showModals('binnacle');
    },
    async onOptionReferencesFile(file) {
      this.selectFile(file);
      await this.searchReferences(file.febosId);
      await this.showModals('references');
    },
    onOptionDownloadFile(file) {
      this.downloadFilePDF({
        febosId: file.febosId,
        imagen: 'si',
        regenerar: 'si',
        tipoImagen: 0
      });
    },
    onOptionDownloadAttachments(file) {
      this.downloadAttachmentFiles({
        febosId: file.febosId,
        comprimir: 'si'
      });
    },
    onOptionCancelFile(file) {
      this.selectFile(file);
      this.showModals('cancelFile');
    },
    onOptionProcessFile(file) {
      this.selectFile(file);
      this.showModals('processFile');
    },
    onOptionArchiveFile(file) {
      this.selectFile(file);
      this.showModals('archiveFile');
    },
    onOptionReturnFile(file) {
      this.selectFile(file);
      this.showModals('returnFile');
    },
    onResponseFile(file) {
      this.selectFile(file);
      this.showModals('answerFileAguasAndinas');
    },
    async onViewResponseFile(file) {
      this.selectFile(file);
      await this.getFileDnt({
        febosId: file.febosId,
        dnt: 'si',
        retornarDnt: 'si',
        destinatarios: 'si',
        referencias: 'si',
        adjuntos: 'si',
        metadata: 'si'
      });
      await this.showModals('PopUpViewResponseAguasAndinas');
    },
    onOptionSendToFlowFile(file) {
      this.selectFile(file);
      return router.push({
        name: 'files-wizard-update',
        params: {
          wizard: 'flujo',
          id: file.febosId
        }
      });
    },
    async onOptionGetParticipants(file) {
      this.selectFile(file);
      await this.getFileDnt({
        febosId: file.febosId,
        destinatarios: 'si'
      });
      await this.showModals('participantsFile');
    },
    async onOptionGetComments(file) {
      this.selectFile(file);
      await this.getFileComments({
        febosId: file.febosId
      });
      await this.showModals('commentsFile');
    },
    async onOptionSendFile(file) {
      await this.getUsersCompany({
        empresaId: this.company.id,
        pagina: 1,
        filas: 9999,
        buscarInfoExtra: 'si',
        filtroInfoExtra: 'CARGO'
      });
      await this.getGroupsCompany({
        empresaId: this.company.id
      });
      this.selectFile(file);
      await this.showModals('sendFile');
    },
    async onOptionNotifyFile(file) {
      await this.getUsersCompany({
        empresaId: this.company.id,
        pagina: 1,
        filas: 9999
      });
      this.selectFile(file);
      await this.showModals('notifyFile');
    },
    async updateSentMetadata(action, metadata) {
      await this.updateSentMetadataStatus({
        febosId: this.file.febosId,
        metadata
      });
      this.$vs.notify({
        title: 'Genial!',
        text: 'El expediente se actualizó correctamente',
        color: 'success',
        time: 5000,
        position: 'top-center'
      });
    },
    onOptionMarkSentFile(file, action) {
      this.selectFile(file);
      const actionMessage = action === 'enviar' ? 'enviado' : 'no enviado';
      const valueMetadata = action === 'enviar' ? 'Y' : 'N';
      const metadata = {
        nombre: 'ENVIADO_OPEN_TEXT',
        valor: valueMetadata,
        tipo: 1
      };
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: 'Atención',
        text: `Este expediente quedará marcado como ${actionMessage}, ¿Estás de acuerdo?`,
        cancelText: 'Cancelar',
        acceptText: 'Confirmar',
        accept: () => this.updateSentMetadata(action, metadata)
      });
    },
    async onOptionSendControlFile(file) {
      this.selectFile(file);
      const toProcess = {
        febosId: file.febosId,
        estadoId: 70,
        comentario: this.comment
      };
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: 'Heey!',
        text: 'Si continuas éste expediente quedará marcado como enviado a Contraloría',
        cancelText: 'Cancelar',
        acceptText: 'Confirmar',
        accept: async () => {
          await this.controlDntFileED(toProcess);
          await this.$bvToast.toast(
            'Vale, no olvides volver para tramitarlo',
            {
              title: '¡Genial!',
              variant: 'primary',
              pauseOnHover: true,
              solid: true,
              autoHideDelay: 4000
            }
          );
        },
        cancel: () => {
        }
      });
    },
    async getProcessDocument(file) {
      // this.loading = true;
      this.$bvToast.toast(
        'En unos segundos podrás ver el acta de procesos',
        {
          title: '¡Hola!',
          variant: 'primary',
          pauseOnHover: true,
          solid: true,
          autoHideDelay: 5000
        }
      );
      const response = await getProcessDocument(file.febosId);
      window.open(response.data.ruta, '_blank');
      // this.loading = false;
    },
    async onOptionControlReceived(file) {
      this.selectFile(file);
      await this.getUserSigns(this.company.iut);
      await this.showModals('controlReceived');
    },
    onOptionOpenActivityBoard(file) {
      this.selectFile(file);
      this.$router.push({
        name: 'file-activities',
        params: { id: file.febosId }
      });
    },
    onTicketFile(file) {
      this.selectFile(file);
      this.showModals('ticketFile');
    },
    async onSendDocDigital(file) {
      this.selectFile(file);
      await this.getFileDnt({
        febosId: file.febosId,
        dnt: 'si',
        retornarDnt: 'si',
        destinatarios: 'si',
        etiquetas: 'si',
        referencias: 'si',
        adjuntos: 'si',
        metadata: 'si',
        docDigitalAutores: 'si',
        docDigitalParticipantes: 'si'
      });
      await this.showModals('sendToDocDigital');
      await this.fetchOptionsDocDigital();
    },
    async updatePrivacity(file) {
      this.selectFile(file);
      await this.showModals('updatePrivacity');
    }
  }
};

</script>
